export default {
  container: {
    '&::after': {
      visibility: function visibility(props) {
        return props.required ? 'inherit' : 'hidden';
      },
      content: '"*"',
      paddingLeft: '0.3rem'
    }
  }
};